module.exports = __webpack_public_path__ + "img/02_4_4_1.365b81c4.png";